import { History as HistoryIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import { ResourceTypes } from 'parkchirp-shared/enums';
import { FC, useContext } from 'react';
import { CommonContext } from '../../contexts';
import { AuditHistoryModal } from './auditHistoryModal';

type ModalProps = {
	title: string;
	resourceId: string;
	resourceType: ResourceTypes;
	timezone?: string;
};

export const AuditHistoryGridAction: FC<ModalProps> = ({ title, resourceId, resourceType, timezone }) => {
	const { setShowDialog, hasComponentAccess, AccessControlledComponents } = useContext(CommonContext);

	const handleAuditHistory = async () => {
		const auditHistory = (
			<AuditHistoryModal
				title={title}
				resourceId={String(resourceId)}
				resourceType={resourceType}
				timezone={timezone}
				onClose={() => {
					setShowDialog(null);
				}}
			/>
		);

		setShowDialog(auditHistory);
	};

	return hasComponentAccess(AccessControlledComponents.AuditHistoryTable) ? (
		<GridActionsCellItem icon={<HistoryIcon />} label='View Audit History' onClick={() => handleAuditHistory()} />
	) : null;
};
